import { lazy } from "react";

const Gym = lazy(() => import("@views/Order/Gym"))
const Sports = lazy(() => import("@views/Order/Sports"))
// const Hospital = lazy(() => import("@views/Order/Hospital"))
// const Library = lazy(() => import("@views/Order/Library"))

const OrderRoutes = [
    {
        path: '/order/sport-hall',
        element: <Sports/>
    },
    {
        path: '/order/fitness',
        element: <Gym/>
    },
    // {
    //     path: 'service/order/hospital/',
    //     element: <Hospital/>
    // },
    // {
    //     path: 'service/order/library/',
    //     element: <Library/>
    // },
]
export default OrderRoutes
